import React from "react";
import { Field } from "react-final-form";
import CheckboxRow from "../shared/CheckboxRow";

/**
 * RffBooleanCheckbox — a single checklist item wired to react-final-form. Stores
 * a boolean true/false (not the HTML "on" string) so downstream conditionals can
 * test `values.x === true`. Meant to be stacked inside a <RffCheckboxGroup> as a
 * "check all that apply" list.
 *
 * Unlike the other Rff* fields it does not use RffInputWrapper — the label sits
 * to the right of the box, not above it. When one question drives a list of
 * options against a SINGLE array field, use RffCheckboxArrayField instead.
 */
const RffBooleanCheckbox = ({ name, label, onChange, disabled, sx }) => (
  <Field
    name={name}
    render={({ input }) => (
      <CheckboxRow
        checked={input.value === true}
        disabled={disabled}
        label={label}
        sx={sx}
        onChange={(checked) => {
          input.onChange(checked);
          if (typeof onChange === "function") onChange(checked);
        }}
      />
    )}
  />
);

export default RffBooleanCheckbox;
